// CustomAccordion.jsx
import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  styled
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  // border: '1px solid #606DB0',
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  borderRadius: '4px',
  '&:focus': {
    border: '1px solid #606DB0'
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '4px',
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: '#f0f0f0',
    color: 'inherit',
  },
  '&:focus': {
    backgroundColor: '#f0f0f0',
    color: 'inherit',
    border: '1px solid #606DB0'
  },
  '&[aria-expanded="true"]': {
    backgroundColor: '#f9f9f9',
    color: 'inherit',
  },
  '& .MuiTypography-root': {
    color: 'inherit',
  }, 
}));


const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: '#f9f9f9', 
  borderRadius: '4px',
}));


export default function CustomAccordion({ title, children }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  return (
    <StyledAccordion expanded={expanded} onChange={handleChange}>
      <StyledAccordionSummary
        expandIcon={
          <span style={{ color: '#606DB0' }}>
            {expanded ? <RemoveIcon /> : <AddIcon />}
          </span>
        }
        aria-controls="content"
        id="header"
      >
        <Typography component="span">{title}</Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <Typography>{children}</Typography>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
}
